import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styles from './styles/userData.module.css';
import UserDataHeader from './UserDataHeader';
import UserDataBody from './UserDataBody';
import AddUser from '../Setup/components/AddUser';

// ⬇️ import your reusable AddUser component

/**
 * Optional: map the backend user object to AddUser.initialUser shape
 * (kept simple since your AddUser expects nearly the same keys)
 */
function mapToInitialUser(u: any) {
  if (!u) return undefined;
  return {
    _id: u._id,
    firstName: u.firstName ?? '',
    lastName: u.lastName ?? '',
    email: u.email ?? '',
    phone: u.phone ?? '',
    assignedSites: Array.isArray(u.assignedSites) ? u.assignedSites : [],
    companyPermissions: u.companyPermissions ?? {},
    sitePermissions: u.sitePermissions ?? {},
    userType: u.userType ?? 'USER',
  };
}

const UserData: React.FC<any> = () => {
  const [userDataHeaderIndex, setUserDataHeaderIndex] = useState(0);
  const { users } = useSelector((state: any) => state.allUsers);
  const { id } = useParams();

  const targetUser = useMemo(() => {
    const tUser = users?.find((u: any) => u._id === id);

    return tUser;
  }, [users, id]);

  // Guard: still loading or not found
  if (!users) {
    return <div className={styles.wrapper}>Loading users…</div>;
  }
  if (!targetUser) {
    return <div className={styles.wrapper}>User not found.</div>;
  }

  const initialUser = mapToInitialUser(targetUser);

  // Render panel based on header index
  const renderPanel = () => {
    switch (userDataHeaderIndex) {
      case 0:
        // EDIT USER (pre-populated)
        return (
          <AddUser
            mode="edit"
            initialUser={initialUser}
            // Close the editor by switching tabs/section after submit or cancel
            setAddUserActive={() => setUserDataHeaderIndex(1)}
          />
        );

      case 1:
        // Example: details view (replace with your actual content)
        return <UserDataBody hireDate={'11/25/2025'} />;

      // Add more cases as your header tabs grow
      default:
        return (
          <div style={{ padding: 16 }}>Select a panel from the header.</div>
        );
    }
  };

  return (
    <div className={styles.wrapper}>
      <UserDataHeader
        userDataIndex={userDataHeaderIndex}
        setUserDataIndex={setUserDataHeaderIndex}
        userStatus={
          targetUser?.status ?? (targetUser.active ? 'Active' : 'Inactive')
        }
        firstName={targetUser?.firstName ?? ''}
        lastName={targetUser?.lastName ?? ''}
      />
      {renderPanel()}
    </div>
  );
};

export default UserData;
